/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ label: NonNullable<unknown>, date: NonNullable<unknown> }} Sub_Addons_Storage_Schedule_ChangeInputs */



/**
* | output |
* | --- |
* | "Your storage will change to {label} on {date}. Select your current tier to cancel, or pick a different tier." |
*
* @param {Sub_Addons_Storage_Schedule_ChangeInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const sub_addons_storage_schedule_change = /** @type {((inputs: Sub_Addons_Storage_Schedule_ChangeInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sub_Addons_Storage_Schedule_ChangeInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Ihr Speicher wird am ${i?.date} auf ${i?.label} geändert. Wählen Sie Ihre aktuelle Stufe zum Abbrechen oder eine andere Stufe.`)
	return /** @type {LocalizedString} */ (`Your storage will change to ${i?.label} on ${i?.date}. Select your current tier to cancel, or pick a different tier.`)
});